
<div [ngStyle] = "this.sharedService.customStyle('bodyTheme')" style="height: 98%;" >
    <router-outlet ></router-outlet>
</div>

